import React from 'react'

import Label from 'components/base/Form/Label'
import Input from 'components/base/Form/Input'
import Tooltip from 'components/blocks/Tooltip'

import { Type as InputType } from '../Input/types'

import { Props } from './types'

import Div from './styles'

const InputGroup: React.FC<Props> = ({
  children,
  isSpaced = false,
  isCentered = true,
  labelCentered,
  loading,
  tooltip,
  type,
  ...inputProps
}): React.ReactElement => {
  const name = inputProps.name || undefined

  const label =
    (inputProps.label && (
      <Label htmlFor={name} center={labelCentered}>
        {inputProps.label}
        {tooltip && <Tooltip>{tooltip}</Tooltip>}
      </Label>
    )) ||
    undefined

  const inputHasChildren =
    ((type === InputType.radio || type === InputType.select) && true) || false
  const inputChildren = (inputHasChildren && children) || undefined
  const childrenProp = (!inputHasChildren && children) || undefined

  const newInputProps = {
    ...inputProps,
    label:
      (Array.isArray(inputProps.label) && inputProps.label[0]) ||
      inputProps.label,
    loading,
  }

  const input =
    (type && (
      <Input type={type} {...newInputProps}>
        {(inputHasChildren && inputChildren) || undefined}
      </Input>
    )) ||
    undefined

  return (
    <Div isSpaced={isSpaced} isCentered={isCentered}>
      {label}
      {input}
      {childrenProp}
    </Div>
  )
}

export * from './types'

export default InputGroup
